module.exports = __webpack_public_path__ + "img/ico-yz4.aaff21ed.png";